// extracted by mini-css-extract-plugin
module.exports = {"tabbedPanel":"TabbedPanel_tabbedPanel","tabHandles":"TabbedPanel_tabHandles","tabHandle":"TabbedPanel_tabHandle","tabBody":"TabbedPanel_tabBody"};